
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    name: 'Swiper',
})
export default class Swiper extends Vue {
    // swiper-items' instance
    public child: any[] = [];
    // current swiper-item index
    public currentIndex: number = 0;
    // swiper-body width
    public currentWidth: number = 0;
    // settimeout
    public timer: any;
    public setWidthTimer: any;
    // touch point
    public touchX: number = 0;
    public offset: number = 0;
    // style
    public isAnimate: boolean = true;

    @Prop()
    public customClass?: string;

    @Prop({ default: '100%' })
    public width!: string | number;

    @Prop({ default: '300px'})
    public height!: string | number;

    // 起始位置
    @Prop({ default: 0 })
    public startIndex!: number;

    // 显示导航点
    @Prop({ default: true })
    public showDot!: boolean;

    // 导航点风格
    @Prop({
        type: String,
        default: 'circle',
        validator(val: string): boolean {
            return ['line', 'circle'].includes(val);
        },
    })
    public dotStyle!: string;

    // 导航点颜色
    @Prop({ default: 'rgba(255, 255, 255, .4)' })
    public dotColor!: string;

    // 导航焦点颜色
    @Prop({ default: '#feaf24' })
    public dotColorActive!: string;

    // 动画效果
    @Prop({ default: true })
    public animation!: boolean;

    // 无缝轮播(in future)
    @Prop({ default: true })
    public seamless!: boolean;

    // 展示时间(unit: ms)
    @Prop({ default: 5000 })
    public duration!: number;

    // 自动播放
    @Prop({ default: true })
    public autoPlay!: boolean;

    @Watch('currentIndex')
    public handleCurrentIndexChange(n: number, o: number) {
        this.$emit('swiper-change', n);
    }

    get marginLeft() {
        return -this.currentWidth * this.currentIndex - this.offset + 'px';
    }

    get childWidth() {
        return this.currentWidth * this.child.length + 'px';
    }

    get maxIndex() {
        return this.child.length - 1;
    }

    get transition() {
        return this.isAnimate ? 'margin-left .25s' : 'none';
    }

    private mounted() {
        this.setCurrentWidth();
        this.isAnimate = this.animation;
        if (this.autoPlay) {
            this.play(this.startIndex);
        }

        window.addEventListener('resize', this.setCurrentWidth);
    }

    private beforeDestroy() {
        clearTimeout(this.timer);
        window.removeEventListener('resize', this.setCurrentWidth);
    }

    private setCurrentWidth() {
        clearTimeout(this.setWidthTimer);
        this.currentWidth = (this.$el as HTMLElement).offsetWidth;
        if (!this.currentWidth) {
            this.setWidthTimer = setTimeout(this.setCurrentWidth, 100);
        }
    }

    private play(index: number) {
        clearTimeout(this.timer);
        this.currentIndex = index;

        this.timer = setTimeout(() => {
            if (index >= this.maxIndex) {
                index = 0;
            } else {
                index += 1;
            }
            this.play(index);
        }, this.duration);
    }

    private onTouchstart(event: any) {
        this.touchX = event.touches[0].clientX;
        clearTimeout(this.timer);
    }

    private onTouchmove(event: any) {
        clearTimeout(this.timer);
        const x = event.touches[0].clientX;
        let ofs = this.touchX - x;

        this.isAnimate = false;
        if (ofs >= 0 && this.currentIndex === this.maxIndex) {
            ofs = 0;
        } else if (ofs < 0 && this.currentIndex === 0) {
            ofs = 0;
        }
        this.offset = ofs;
    }

    private onTouchend(event: any) {
        let index: number = this.currentIndex;
        if (Math.abs(this.offset) >= this.currentWidth * .3) {
            index = this.offset >= 0
                ? (this.currentIndex + 1)
                : (this.currentIndex - 1);
            if (index < 0) {
                index = 0;
            } else if (index > this.maxIndex) {
                index = this.maxIndex;
            }
            this.currentIndex = index;
        }
        this.offset = 0;
        this.touchX = 0;
        this.isAnimate = this.animation;

        if (this.autoPlay) {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                const next = index === this.maxIndex ? 0 : index++;
                this.play(next);
            }, this.duration);
        }

    }
}
